import React, { Component } from 'react';
import Modal from 'react-modal';
import './modal.css';
import firebase from 'firebase';
import Alert from 'react-s-alert';
import secondaryApp from '../BD/secondaryApp';
import {sendLog} from '../../util'
const database=firebase.database();


const customStyles = {
	content : {
	  top                   : '50%',
	  left                  : '50%',
	  right                 : 'auto',
	  bottom                : 'auto',
	  transform             : 'translate(-50%, -50%)',
	  width                 : '450px',
	  height: '550px',	 
	  
	}
  };


class Modal_Empresa extends Component{
	
	constructor(){
		
		super();
		
		this.state={
			
			isActive:false,
			uid:'',
			checkAdmin:false
		}
		

		this.empresaRef = database.ref().child('Empresa');
		this.tarifasRef=database.ref().child('Tarifas');
		
		
		this.handleSubmit=this.handleSubmit.bind(this);
		this.handleKeyPressNumeros=this.handleKeyPressNumeros.bind(this);
		
	}
	
	componentWillMount(){
		
		Modal.setAppElement('body');
	}

	componentDidMount(){
		this.checkSAdmin();
	}
	
	
	toggleModal=()=>{
		
		this.setState({
			
			isActive:!this.state.isActive
		})
		
	}

	checkSAdmin = () => {
		let id = firebase.auth().currentUser.uid;
		firebase.database().ref("superAdmin").once("value").then(rows => {
			rows.forEach( element => {
				let data = element.val();
				data.key = element.key;
				if (data.key === id) {
					this.setState({checkAdmin:true})
				}
			})
		})
	}
	
	handleSubmit(event){
	
	
		let codigo_empresa=this.codigoEmpresa.value;
		let correo=this.correo.value;
		let estado=this.estado.value;
		let razon_social=this.razon_social.value;
		let representante=this.representante.value;
		let telefono=this.telefono.value;
		let contrasena=this.contrasena.value;
		let confirmacion=this.confirm_contrasena.value;
		
		let d_5km=this.d_5km.value;
		let d_10km=this.d_10km.value;
		let d_15km=this.d_15km.value;
		let d_mas15km=this.d_mas15km.value;
		
		
		if(confirmacion===contrasena){
			
			//Creando cuenta para el conductor
		secondaryApp.auth().createUserWithEmailAndPassword(this.correo.value,this.contrasena.value)
		.then(user => {
				
				this.state.uid=user.user.uid

				
				this.empresaRef.child(this.state.uid).update({
					
					codigo_activacion:'54545',
					codigo_empresa:codigo_empresa,
					correo:correo,
					estado:estado,
					razon_social:razon_social,
					representante:representante,
					telefono_empresa:telefono
			
				})
				
				
				this.tarifasRef.child(this.state.uid).update({
					
						nombre_tarifa:codigo_empresa,
						uid_empresa:this.state.uid,
						d_5km:d_5km,
						d_10km:d_10km,
						d_15km:d_15km,
						d_mas15km:d_mas15km
										
				})
				
				Alert.success('Datos guardados correctamente', {
					effect: 'genie',
					position: 'bottom-right',
					timeout:2000			
				});
				secondaryApp.auth().signOut();	
				sendLog({ tipo: 'empresa_nueva', informacion_extra: {empresa: this.state.uid}});
				this.toggleModal();
						
		})
			.catch(error =>{
			
				let msj='Error al ingresar usuario';
			
				if(error.code==='auth/email-already-in-use'){	
					msj='Ya existe una cuenta con la dirección de correo electrónico especificada.';
				}
				else if(error.code==='auth/invalid-email'){					
					msj='Dirección de correo electronico no valida.';					
				}
				
				else if(error.code==='auth/weak-password'){
					
					msj='La contraseña ingresada no es demasiado fuerte.';
						
				}

				Alert.error(msj, {
						effect: 'genie',
						position: 'bottom-right',
						timeout:2000			
				});
			
				
		});
			

		}
		else{			
			Alert.error('Las contraseñas ingresadas no coinciden', {
					effect: 'genie',
					position: 'bottom-right',
					timeout:2000			
			});
		}
		
		
		event.preventDefault();
		
	}
	
	handleKeyPressNumeros(e){
	
		let tecla=e.which;		
		let patron =/^[0-9]+$/;
		let tecla_final = String.fromCharCode(tecla);
		
		let rs=patron.test(tecla_final);
		
		if(!rs){
			e.preventDefault();		
		}
	
	}
	
	
	
	
	render(){
		let {checkAdmin} = this.state;
		return(
		
			<div >
				{checkAdmin &&
					<button className="btn btn-primary" onClick={this.toggleModal}><span className="glyphicon glyphicon-plus"> </span> Nuevo</button>
				}
					<Modal isOpen={this.state.isActive} onRequestClose={this.toggleModal}  style={customStyles} >
						
						<form method="POST" action="" onSubmit={this.handleSubmit}>
						
							<h3>Agregar Empresa</h3>
							<hr/>
								<div className="form-group">
									<label htmlFor="empresa" >Nombre de la empresa:</label>
									<input 	type="text" className="form-control" name="empresa"
										ref={input => {this.codigoEmpresa=input;}}
										placeholder="Empresa"
										autoComplete="off" required
								 />
								</div>
								
								<div className="form-group">
									<label htmlFor="razon_social" >Razon Social:</label>
									<input type="text" className="form-control" name="razon_social" 
										ref={input => {this.razon_social=input;}}
										placeholder="Razon Social"
										autoComplete="off" required
									/>
								</div>
	
						
								<div className="form-group">
									<label htmlFor="telefono" >Telefono:</label>
									<input type="text" className="form-control" name="telefono"
										ref={input => {this.telefono=input;}}
										onKeyPress={this.handleKeyPressNumeros}
										placeholder="Telefono" maxLength="8" minLength="8"
										autComplete="off" required
									 />
								</div>
								
								<div className="form-group">
									<label  htmlFor="correo" >Correo:</label>
									<input type="text" className="form-control" name="correo"
										ref={input => {this.correo=input;}}
										placeholder="correo"
										autoComplete="off" required
									 />
								</div>
								<div className="form-group">
									<label htmlFor="contrasena">Contraseña</label>
									<input type="password" className="form-control" name="contrasena"
									ref={input => {this.contrasena=input}}
									autoComplete="off" required placeholder="Contraseña"
									/>
								</div>
								
								<div className="form-group">
									<label htmlFor="confirm-contrasena">Confirmar Contraseña</label>
									<input type="password" className="form-control" name="confirm-contrasena"
									ref={input => {this.confirm_contrasena=input}}
									autoComplete="off" required placeholder="Confirmar Contraseña"
									/>
								</div>

								
								<div className="form-group">
									<label  htmlFor="representante" >Representante:</label>
									<input type="text" className="form-control" name="representante"
										ref={input => {this.representante=input;}}
										placeholder="Representante"
										autocomplete="off" required
									 />
								</div>
								
								<div className="form-group row ">
									<div className="col-md-4">
										<label htmlFor="dui" >Estado:</label>
										<select className="form-control"
											ref={input => {this.estado=input;}}
											defaultValue={this.state.estado}
										>
											<option>Activo</option>
											<option>Inactivo</option>
										</select>
									</div>
								</div>

								<fieldset>
								<p><b>Agregar tarifa</b></p>
								<div className="form-group">
									<label htmlFor="d_5km">5 Km</label>
									<input type="text" autoComplete="off" required placeholder="5 Km"
									defaultValue={this.state.d_5km} className="form-control"
									ref={input => {this.d_5km=input;}}
									/>
								</div>
								<div className="form-group">
									<label htmlFor="d_10km">10 Km</label>
									<input type="text" autoComplete="off" required placeholder="10 Km"
									defaultValue={this.state.d_10km} className="form-control"
									ref={input => {this.d_10km=input;}}
									/>
								</div>
								<div className="form-group">
									<label htmlFor="d_15km">15 Km</label>
									<input type="text" autoComplete="off" required placeholder="15 Km"
									defaultValue={this.state.d_15km} className="form-control"
									ref={input => {this.d_15km=input;}}
									/>
								</div>
								<div className="form-group">
									<label htmlFor="d_mas15km">Mayor a 15 km</label>
									<input type="text" autoComplete="off" required placeholder="Mayor a 15 Km"
									defaultValue={this.state.d_mas15km} className="form-control"
									ref={input => {this.d_mas15km=input;}}
									/>
								</div>
								
							</fieldset>
								
							
							<hr/>

							<button className="btn btn-primary buttons" type="submit" >Guardar</button>
							<button className="btn btn-default buttons btnmargin" onClick={this.toggleModal}>Cerrar</button>
						</form>
					</Modal>
			
			
			
			</div>
		);
	}
}

export default Modal_Empresa;


// WEBPACK FOOTER //
// ./src/Components/Empresa/empresa_modal.jsx